'use client';

import { useTranslations } from 'next-intl';
import { FAQ } from '@/app/components/ui/FAQ';
import { QUESTIONS_CONFIG } from './utils';

const Questions = () => {
  const t = useTranslations('home3.questions');

  // 使用 utils 中的配置函数获取国际化问题列表
  const questions = QUESTIONS_CONFIG(t);

  return (
    <div className="relative flex w-full flex-col justify-center overflow-hidden">
      <FAQ items={questions} title={t('title')} description={t('description')} />
    </div>
  );
};

export default Questions;
